<!-- SwipFx Orders Page (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">
    <app-header [page]="'Orders'"></app-header>

    <main class="container py-4">
        <!-- Header -->
        <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
            <div>
                <h4 class="mb-0 fw-bold">Orders</h4>
                <div class="text-muted small">Track your orders by status</div>
            </div>

            <form [formGroup]="searchForm" (ngSubmit)="submitSearch()">
                <div class="d-flex gap-2">
                    <button class="btn btn-outline-secondary btn-sm" [disabled]="loading" (click)="refresh()">
                        <span *ngIf="!loading">Refresh</span>
                        <span *ngIf="loading">Refreshing...</span>
                    </button>
                    <!-- placeholder only (you said you'll implement filters) -->
                    <div class="input-group input-group-sm" style="width: 240px;">
                        <input class="form-control" formControlName="searchQuery" placeholder="Order ID / Pair" />
                    </div>
                    <button type="submit" class="btn btn-outline-secondary btn-sm"
                        [class.active]="activeTab === 'tabSearch'" (click)="activeTab = 'tabSearch'">
                        Search
                    </button>

                    <button *ngIf="showSearchResult" class="btn btn-outline-danger btn-sm"
                        [class.active]="activeTab === 'tabAll'" (click)="activeTab = 'tabAll'">
                        Clear Search
                    </button>
                </div>
            </form>
        </div>

        <div class="row g-3">
            <!-- LEFT: Buy/Sell boxes -->
            <div class="col-12 col-lg-4">
                <div class="alert alert-danger d-flex align-items-start gap-2" *ngIf="pageBlocker">
                    <div>
                        <div class="fw-bold">Orders temporarily unavailable</div>
                        <div>{{ pageBlocker }}</div>
                        <div class="small mt-1 text-muted" *ngIf="pageBlockerCode">
                            Code: {{ pageBlockerCode }}
                        </div>
                    </div>
                </div>

                <!-- Shared order entry -->
                <app-order-entry
                    title="Create Order"
                    [currencies]="currencies"
                    [fee]="fee"
                    [available]="available"
                    [minimumHaveAmount]="wallet?.currencyRules?.minOrder ?? 0.01"
                    [maximumHaveAmount]="maximumSpendableAmount"
                    [loading]="loading || loadingWallet || !userData"
                    [blockedMessage]="pageBlocker"
                    [errorMessage]="errorObject?.error ? errorObject?.message || '' : ''"
                    [errorButtonText]="errorObject?.showButton ? errorObject?.buttonText || '' : ''"
                    [initialDraft]="pendingDraft"
                    [autoSubmitInitialDraft]="!!pendingDraft"
                    [submissionLocked]="reviewOpen || loading"
                    submitBehavior="emit"
                    (submitted)="handleOrderEntrySubmit($event)"
                    (haveCurrencyChanged)="getWalletFromCurrency($event)"
                    (errorAction)="routeErrorButton()">
                </app-order-entry>

                <div class="text-muted small mt-3"></div>

                <!-- Limits -->
                <div class="card shadow-sm border-0">
                    <div class="card-body p-4">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="fw-bold">Order Limits</div>
                        </div>

                        <!-- LOADING SKELETON -->
                        <div *ngIf="loadingWallet || !wallet" class="card shadow-sm border-0">
                            <div class="card-body p-4">
                                <div class="placeholder-glow">
                                    <div class="placeholder col-12 mb-2"></div>
                                    <div class="placeholder col-12 mb-2"></div>
                                    <div class="placeholder col-12 mb-2"></div>
                                    <div class="placeholder col-8"></div>
                                </div>
                            </div>
                        </div>

                        <hr class="my-3">
                        <div *ngIf="!loadingWallet && wallet">
                            <div class="d-flex justify-content-between mb-2">
                                <div class="text-muted small">Transaction Limit</div>
                                <div class="fw-semibold">
                                    {{ getLimitData(wallet!.tierInfo, "Trade", "perTransactionLimit") || 0 |
                                    smartAmount:wallet!.currency.symbol }}
                                </div>
                            </div>

                            <div class="d-flex justify-content-between mb-2"
                                *ngIf="wallet!.currencyRules.usage.hasApprovedKyc">
                                <div class="text-muted small">Daily Limit</div>
                                <div class="fw-semibold">
                                    {{ getLimitData(wallet!.tierInfo, "Trade", "remainingDailyLimit") || 0 |
                                    smartAmount:wallet!.currency.symbol }} /
                                    {{ getLimitData(wallet!.tierInfo, "Trade", "dailyLimit") || 0 |
                                    smartAmount:wallet!.currency.symbol }}
                                </div>
                            </div>

                            <div class="d-flex justify-content-between mb-2"
                                *ngIf="wallet!.currencyRules.usage.hasApprovedKyc">
                                <div class="text-muted small">Montly Limit</div>
                                <div class="fw-semibold">
                                    {{ getLimitData(wallet!.tierInfo, "Trade", "remainingMonthlyLimit") || 0 |
                                    smartAmount:wallet!.currency.symbol }} /
                                    {{ getLimitData(wallet!.tierInfo, "Trade", "monthlyLimit") || 0 |
                                    smartAmount:wallet!.currency.symbol }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <app-support-context-card
                    class="d-block mt-3"
                    type="order"
                    title="Questions about Instant or Flexible trading?"
                    subtitle="Ask about quotes, liquidity, partial fills, or your latest order.">
                </app-support-context-card>
            </div>


            <!-- RIGHT: Tabs + table -->
            <div class="col-12 col-lg-8">
                <div class="card shadow-sm border-0">
                    <div class="card-body p-0">
                        <!-- Tabs -->
                        <ul class="nav nav-tabs px-3 pt-3" role="tablist">
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" type="button" [class.active]="activeTab === 'tabSearch'"
                                    [disabled]="!showSearchResult" (click)="activeTab = 'tabSearch'"
                                    data-bs-toggle="tab" data-bs-target="#tabSearch" role="tab">
                                    Search Result
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" type="button" [class.active]="activeTab === 'tabAll'"
                                    (click)="activeTab = 'tabAll'" data-bs-toggle="tab" data-bs-target="#tabAll"
                                    type="button" role="tab">
                                    All
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" type="button" [class.active]="activeTab === 'tabOpen'"
                                    (click)="activeTab = 'tabOpen'" data-bs-toggle="tab" data-bs-target="#tabOpen"
                                    type="button" role="tab">
                                    Open
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" type="button" [class.active]="activeTab === 'tabPartial'"
                                    (click)="activeTab = 'tabPartial'" data-bs-toggle="tab" data-bs-target="#tabPartial"
                                    type="button" role="tab">
                                    Partial
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" type="button" [class.active]="activeTab === 'tabCompleted'"
                                    (click)="activeTab = 'tabCompleted'" data-bs-toggle="tab"
                                    data-bs-target="#tabCompleted" type="button" role="tab">
                                    Completed
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" type="button" [class.active]="activeTab === 'tabCancelled'"
                                    (click)="activeTab = 'tabCancelled'" data-bs-toggle="tab"
                                    data-bs-target="#tabCancelled" type="button" role="tab">
                                    Cancelled
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" type="button" [class.active]="activeTab === 'tabFailed'"
                                    (click)="activeTab = 'tabFailed'" data-bs-toggle="tab" data-bs-target="#tabFailed"
                                    type="button" role="tab">
                                    Failed
                                </button>
                            </li>
                        </ul>

                        <!-- Tab panes -->
                        <div class="tab-content p-3">

                            <!-- SEARCH -->
                            <div class="tab-pane fade" [class.show]="activeTab === 'tabSearch'"
                                [class.active]="activeTab === 'tabSearch'" id="tabSearch" role="tabpanel">
                                <!-- LOADING SKELETON -->
                                <div *ngIf="loadingSearchResults" class="card shadow-sm border-0">
                                    <div class="card-body p-4">
                                        <div class="placeholder-glow">
                                            <div class="placeholder col-4 mb-2"></div>
                                            <div class="placeholder col-7 mb-4"></div>
                                            <div class="placeholder col-12 mb-2"></div>
                                            <div class="placeholder col-10 mb-2"></div>
                                            <div class="placeholder col-8"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive" *ngIf="!loadingSearchResults">
                                    <table class="table table-hover align-middle mb-0">
                                        <thead class="table-light">
                                            <tr class="small text-muted">
                                                <th style="min-width:160px;">Order</th>
                                                <th style="min-width:140px;">Pair</th>
                                                <th class="text-end" style="min-width:140px;">Amount</th>
                                                <th class="text-end" style="min-width:140px;">Remaining</th>
                                                <th class="text-end" style="min-width:120px;">Rate</th>
                                                <th style="min-width:120px;">Status</th>
                                                <th style="min-width:160px;">Created</th>
                                                <th class="text-end" style="min-width:160px;">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let order of searchResults">
                                                <td>
                                                    <div class="d-flex align-items-center gap-2">
                                                        <span class="fw-semibold">
                                                            <a href="Javascript:void(0)" class="text-decoration-none"
                                                                (click)="viewOrder(order.id)">{{ shortId(order.id)
                                                                }}</a>
                                                        </span>

                                                        <button type="button" class="btn btn-link p-0 text-muted small"
                                                            (click)="copyToClipboard(order.id)"
                                                            title="Copy full Order ID" style="line-height:1;">
                                                            <i class="bi bi-clipboard"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td class="fw-semibold">{{order.fromCurrency.code}} →
                                                    {{order.toCurrency.code}}</td>
                                                <td class="text-end">{{ order.originalAmount |
                                                    smartAmount:order.fromCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.remainingAmount |
                                                    smartAmount:order.toCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.rate | smartAmount }}
                                                    {{order.toCurrency.code +
                                                    "/"+order.fromCurrency.code}}</td>
                                                <td><span
                                                        [class]="getOrderStatusClass(order.status)">{{order.status}}</span>
                                                </td>
                                                <td class="text-muted small">{{order.createdAt | date:'medium'}}</td>
                                                <td class="text-end">
                                                    <button class="btn btn-outline-secondary btn-sm"
                                                        (click)="viewOrder(order.id)">View</button>
                                                    <button class="btn btn-outline-danger btn-sm"
                                                        *ngIf="order.status == 'Open' || order.status == 'Partial'"
                                                        (click)="cancelOrder(order.id)">Cancel</button>
                                                </td>
                                            </tr>
                                            <tr *ngIf="searchResults.length === 0">
                                                <td colspan="8" class="text-center py-5 text-muted">
                                                    <div class="fw-semibold">No search results</div>
                                                    <div class="small">Try a different search query.</div>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <!-- ALL -->
                            <div class="tab-pane fade show active" [class.show]="activeTab === 'tabAll'"
                                [class.active]="activeTab === 'tabAll'" id="tabAll" role="tabpanel">
                                <!-- LOADING SKELETON -->
                                <div *ngIf="loadingAllOrders" class="card shadow-sm border-0">
                                    <div class="card-body p-4">
                                        <div class="placeholder-glow">
                                            <div class="placeholder col-4 mb-2"></div>
                                            <div class="placeholder col-7 mb-4"></div>
                                            <div class="placeholder col-12 mb-2"></div>
                                            <div class="placeholder col-10 mb-2"></div>
                                            <div class="placeholder col-8"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive" *ngIf="!loadingAllOrders">
                                    <table class="table table-hover align-middle mb-0">
                                        <thead class="table-light">
                                            <tr class="small text-muted">
                                                <th style="min-width:160px;">Order</th>
                                                <th style="min-width:140px;">Pair</th>
                                                <th class="text-end" style="min-width:140px;">Amount</th>
                                                <th class="text-end" style="min-width:140px;">Remaining</th>
                                                <th class="text-end" style="min-width:120px;">Rate</th>
                                                <th style="min-width:120px;">Status</th>
                                                <th style="min-width:160px;">Created</th>
                                                <th class="text-end" style="min-width:160px;">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let order of allOrders">
                                                <td>
                                                    <div class="d-flex align-items-center gap-2">
                                                        <span class="fw-semibold">
                                                            <a href="Javascript:void(0)" class="text-decoration-none"
                                                                (click)="viewOrder(order.id)">{{ shortId(order.id)
                                                                }}</a>
                                                        </span>

                                                        <button type="button" class="btn btn-link p-0 text-muted small"
                                                            (click)="copyToClipboard(order.id)"
                                                            title="Copy full Order ID" style="line-height:1;">
                                                            <i class="bi bi-clipboard"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td class="fw-semibold">{{order.fromCurrency.code}} →
                                                    {{order.toCurrency.code}}</td>
                                                <td class="text-end">{{ order.originalAmount |
                                                    smartAmount:order.fromCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.remainingAmount |
                                                    smartAmount:order.toCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.rate | smartAmount }}
                                                    {{order.toCurrency.code +
                                                    "/"+order.fromCurrency.code}}</td>
                                                <td><span
                                                        [class]="getOrderStatusClass(order.status)">{{order.status}}</span>
                                                </td>
                                                <td class="text-muted small">{{order.createdAt | date:'medium'}}</td>
                                                <td class="text-end">
                                                    <button class="btn btn-outline-secondary btn-sm"
                                                        (click)="viewOrder(order.id)">View</button>
                                                    <button class="btn btn-outline-danger btn-sm"
                                                        *ngIf="order.status == 'Open' || order.status == 'Partial'"
                                                        (click)="cancelOrder(order.id)">Cancel</button>
                                                </td>
                                            </tr>
                                            <tr *ngIf="allOrders.length === 0">
                                                <td colspan="8" class="text-center py-5 text-muted">
                                                    <div class="fw-semibold">No orders yet</div>
                                                    <div class="small">Your orders will appear here.</div>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>

                                <app-pagination *ngIf="allOrdersMeta && allOrdersMeta.totalRows > 0" [url]='url'
                                    [counts]='allOrdersMeta!' (refresh)="getOrder(null, $event)"></app-pagination>

                                <!-- Footer -->
                                <!-- <div class="d-flex flex-wrap gap-2 justify-content-between align-items-center p-3 border-top">
                                    <div class="small text-muted">Showing 5 orders</div>
                                    <div class="d-flex gap-2">
                                        <button class="btn btn-outline-secondary btn-sm" disabled>Prev</button>
                                        <button class="btn btn-outline-secondary btn-sm">Next</button>
                                    </div>
                                </div> -->
                            </div>

                            <!-- OPEN -->
                            <div class="tab-pane fade" id="tabOpen" role="tabpanel">
                                <!-- LOADING SKELETON -->
                                <div *ngIf="loadingOpenOrders" class="card shadow-sm border-0">
                                    <div class="card-body p-4">
                                        <div class="placeholder-glow">
                                            <div class="placeholder col-4 mb-2"></div>
                                            <div class="placeholder col-7 mb-4"></div>
                                            <div class="placeholder col-12 mb-2"></div>
                                            <div class="placeholder col-10 mb-2"></div>
                                            <div class="placeholder col-8"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive" *ngIf="!loadingOpenOrders">
                                    <table class="table table-hover align-middle mb-0">
                                        <thead class="table-light">
                                            <tr class="small text-muted">
                                                <th style="min-width:160px;">Order</th>
                                                <th style="min-width:140px;">Pair</th>
                                                <th class="text-end" style="min-width:140px;">Amount</th>
                                                <th class="text-end" style="min-width:140px;">Remaining</th>
                                                <th class="text-end" style="min-width:120px;">Rate</th>
                                                <th style="min-width:120px;">Status</th>
                                                <th style="min-width:160px;">Created</th>
                                                <th class="text-end" style="min-width:160px;">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let order of openOrders">
                                                <td>
                                                    <div class="d-flex align-items-center gap-2">
                                                        <span class="fw-semibold">
                                                            <a href="Javascript:void(0)" class="text-decoration-none"
                                                                (click)="viewOrder(order.id)">{{ shortId(order.id)
                                                                }}</a>
                                                        </span>

                                                        <button type="button" class="btn btn-link p-0 text-muted small"
                                                            (click)="copyToClipboard(order.id)"
                                                            title="Copy full Order ID" style="line-height:1;">
                                                            <i class="bi bi-clipboard"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td class="fw-semibold">{{order.fromCurrency.code}} →
                                                    {{order.toCurrency.code}}</td>
                                                <td class="text-end">{{ order.originalAmount |
                                                    smartAmount:order.fromCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.remainingAmount |
                                                    smartAmount:order.toCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.rate | smartAmount }}
                                                    {{order.toCurrency.code +
                                                    "/"+order.fromCurrency.code}}</td>
                                                <td><span
                                                        [class]="getOrderStatusClass(order.status)">{{order.status}}</span>
                                                </td>
                                                <td class="text-muted small">{{order.createdAt | date:'medium'}}</td>
                                                <td class="text-end">
                                                    <button class="btn btn-outline-secondary btn-sm"
                                                        (click)="viewOrder(order.id)">View</button>
                                                    <button class="btn btn-outline-danger btn-sm"
                                                        *ngIf="order.status == 'Open' || order.status == 'Partial'"
                                                        (click)="cancelOrder(order.id)">Cancel</button>
                                                </td>
                                            </tr>
                                            <tr *ngIf="openOrders.length === 0">
                                                <td colspan="8" class="text-center py-5 text-muted">
                                                    <div class="fw-semibold">No open orders yet</div>
                                                    <div class="small">Your open orders will appear here.</div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <app-pagination *ngIf="openOrdersMeta && openOrdersMeta.totalRows > 0" [url]='url'
                                    [counts]='openOrdersMeta' (refresh)="getOrder('Open', $event)"></app-pagination>
                            </div>

                            <!-- PARTIAL -->
                            <div class="tab-pane fade" id="tabPartial" role="tabpanel">
                                <!-- LOADING SKELETON -->
                                <div *ngIf="loadingPartialOrders" class="card shadow-sm border-0">
                                    <div class="card-body p-4">
                                        <div class="placeholder-glow">
                                            <div class="placeholder col-4 mb-2"></div>
                                            <div class="placeholder col-7 mb-4"></div>
                                            <div class="placeholder col-12 mb-2"></div>
                                            <div class="placeholder col-10 mb-2"></div>
                                            <div class="placeholder col-8"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive" *ngIf="!loadingPartialOrders">
                                    <table class="table table-hover align-middle mb-0">
                                        <thead class="table-light">
                                            <tr class="small text-muted">
                                                <th style="min-width:160px;">Order</th>
                                                <th style="min-width:140px;">Pair</th>
                                                <th class="text-end" style="min-width:140px;">Amount</th>
                                                <th class="text-end" style="min-width:140px;">Remaining</th>
                                                <th class="text-end" style="min-width:120px;">Rate</th>
                                                <th style="min-width:120px;">Status</th>
                                                <th style="min-width:160px;">Created</th>
                                                <th class="text-end" style="min-width:160px;">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let order of partialOrders">
                                                <td>
                                                    <div class="d-flex align-items-center gap-2">
                                                        <span class="fw-semibold">
                                                            <a href="Javascript:void(0)" class="text-decoration-none"
                                                                (click)="viewOrder(order.id)">{{ shortId(order.id)
                                                                }}</a>
                                                        </span>

                                                        <button type="button" class="btn btn-link p-0 text-muted small"
                                                            (click)="copyToClipboard(order.id)"
                                                            title="Copy full Order ID" style="line-height:1;">
                                                            <i class="bi bi-clipboard"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td class="fw-semibold">{{order.fromCurrency.code}} →
                                                    {{order.toCurrency.code}}</td>
                                                <td class="text-end">{{ order.originalAmount |
                                                    smartAmount:order.fromCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.remainingAmount |
                                                    smartAmount:order.toCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.rate | smartAmount }}
                                                    {{order.toCurrency.code +
                                                    "/"+order.fromCurrency.code}}</td>
                                                <td><span
                                                        [class]="getOrderStatusClass(order.status)">{{order.status}}</span>
                                                </td>
                                                <td class="text-muted small">{{order.createdAt | date:'medium'}}</td>
                                                <td class="text-end">
                                                    <button class="btn btn-outline-secondary btn-sm"
                                                        (click)="viewOrder(order.id)">View</button>
                                                    <button class="btn btn-outline-danger btn-sm"
                                                        *ngIf="order.status == 'Open' || order.status == 'Partial'"
                                                        (click)="cancelOrder(order.id)">Cancel</button>
                                                </td>
                                            </tr>
                                            <tr *ngIf="partialOrders.length === 0">
                                                <td colspan="8" class="text-center py-5 text-muted">
                                                    <div class="fw-semibold">No partial orders yet</div>
                                                    <div class="small">Your partial orders will appear here.</div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <app-pagination *ngIf="partialOrdersMeta && partialOrdersMeta.totalRows > 0" [url]='url'
                                    [counts]='partialOrdersMeta'
                                    (refresh)="getOrder('Partial', $event)"></app-pagination>
                            </div>

                            <!-- COMPLETED -->
                            <div class="tab-pane fade" id="tabCompleted" role="tabpanel">
                                <!-- LOADING SKELETON -->
                                <div *ngIf="loadingCompletedOrders" class="card shadow-sm border-0">
                                    <div class="card-body p-4">
                                        <div class="placeholder-glow">
                                            <div class="placeholder col-4 mb-2"></div>
                                            <div class="placeholder col-7 mb-4"></div>
                                            <div class="placeholder col-12 mb-2"></div>
                                            <div class="placeholder col-10 mb-2"></div>
                                            <div class="placeholder col-8"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive" *ngIf="!loadingCompletedOrders">
                                    <table class="table table-hover align-middle mb-0">
                                        <thead class="table-light">
                                            <tr class="small text-muted">
                                                <th style="min-width:160px;">Order</th>
                                                <th style="min-width:140px;">Pair</th>
                                                <th class="text-end" style="min-width:140px;">Amount</th>
                                                <th class="text-end" style="min-width:140px;">Remaining</th>
                                                <th class="text-end" style="min-width:120px;">Rate</th>
                                                <th style="min-width:120px;">Status</th>
                                                <th style="min-width:160px;">Created</th>
                                                <th class="text-end" style="min-width:160px;">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let order of completedOrders">
                                                <td>
                                                    <div class="d-flex align-items-center gap-2">
                                                        <span class="fw-semibold">
                                                            <a href="Javascript:void(0)" class="text-decoration-none"
                                                                (click)="viewOrder(order.id)">{{ shortId(order.id)
                                                                }}</a>
                                                        </span>

                                                        <button type="button" class="btn btn-link p-0 text-muted small"
                                                            (click)="copyToClipboard(order.id)"
                                                            title="Copy full Order ID" style="line-height:1;">
                                                            <i class="bi bi-clipboard"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td class="fw-semibold">{{order.fromCurrency.code}} →
                                                    {{order.toCurrency.code}}</td>
                                                <td class="text-end">{{ order.originalAmount |
                                                    smartAmount:order.fromCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.remainingAmount |
                                                    smartAmount:order.toCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.rate | smartAmount }}
                                                    {{order.toCurrency.code +
                                                    "/"+order.fromCurrency.code}}</td>
                                                <td><span
                                                        [class]="getOrderStatusClass(order.status)">{{order.status}}</span>
                                                </td>
                                                <td class="text-muted small">{{order.createdAt | date:'medium'}}</td>
                                                <td class="text-end">
                                                    <button class="btn btn-outline-secondary btn-sm"
                                                        (click)="viewOrder(order.id)">View</button>
                                                    <button class="btn btn-outline-danger btn-sm"
                                                        *ngIf="order.status == 'Open' || order.status == 'Partial'"
                                                        (click)="cancelOrder(order.id)">Cancel</button>
                                                </td>
                                            </tr>
                                            <tr *ngIf="completedOrders.length === 0">
                                                <td colspan="8" class="text-center py-5 text-muted">
                                                    <div class="fw-semibold">No completed orders yet</div>
                                                    <div class="small">Your completed orders will appear here.</div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <app-pagination *ngIf="completedOrdersMeta && completedOrdersMeta.totalRows > 0"
                                    [url]='url' [counts]='completedOrdersMeta'
                                    (refresh)="getOrder('Completed', $event)"></app-pagination>
                            </div>

                            <!-- CANCELLED -->
                            <div class="tab-pane fade" id="tabCancelled" role="tabpanel">
                                <!-- LOADING SKELETON -->
                                <div *ngIf="loadingCancelledOrders" class="card shadow-sm border-0">
                                    <div class="card-body p-4">
                                        <div class="placeholder-glow">
                                            <div class="placeholder col-4 mb-2"></div>
                                            <div class="placeholder col-7 mb-4"></div>
                                            <div class="placeholder col-12 mb-2"></div>
                                            <div class="placeholder col-10 mb-2"></div>
                                            <div class="placeholder col-8"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive" *ngIf="!loadingCancelledOrders">
                                    <table class="table table-hover align-middle mb-0">
                                        <thead class="table-light">
                                            <tr class="small text-muted">
                                                <th style="min-width:160px;">Order</th>
                                                <th style="min-width:140px;">Pair</th>
                                                <th class="text-end" style="min-width:140px;">Amount</th>
                                                <th class="text-end" style="min-width:140px;">Remaining</th>
                                                <th class="text-end" style="min-width:120px;">Rate</th>
                                                <th style="min-width:120px;">Status</th>
                                                <th style="min-width:160px;">Created</th>
                                                <th class="text-end" style="min-width:160px;">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let order of cancelledOrders">
                                                <td>
                                                    <div class="d-flex align-items-center gap-2">
                                                        <span class="fw-semibold">
                                                            <a href="Javascript:void(0)" class="text-decoration-none"
                                                                (click)="viewOrder(order.id)">{{ shortId(order.id)
                                                                }}</a>
                                                        </span>

                                                        <button type="button" class="btn btn-link p-0 text-muted small"
                                                            (click)="copyToClipboard(order.id)"
                                                            title="Copy full Order ID" style="line-height:1;">
                                                            <i class="bi bi-clipboard"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td class="fw-semibold">{{order.fromCurrency.code}} →
                                                    {{order.toCurrency.code}}</td>
                                                <td class="text-end">{{ order.originalAmount |
                                                    smartAmount:order.fromCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.remainingAmount |
                                                    smartAmount:order.toCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.rate | smartAmount }}
                                                    {{order.toCurrency.code +
                                                    "/"+order.fromCurrency.code}}</td>
                                                <td><span
                                                        [class]="getOrderStatusClass(order.status)">{{order.status}}</span>
                                                </td>
                                                <td class="text-muted small">{{order.createdAt | date:'medium'}}</td>
                                                <td class="text-end">
                                                    <button class="btn btn-outline-secondary btn-sm"
                                                        (click)="viewOrder(order.id)">View</button>
                                                    <button class="btn btn-outline-danger btn-sm"
                                                        *ngIf="order.status == 'Open' || order.status == 'Partial'"
                                                        (click)="cancelOrder(order.id)">Cancel</button>
                                                </td>
                                            </tr>
                                            <tr *ngIf="cancelledOrders.length === 0">
                                                <td colspan="8" class="text-center py-5 text-muted">
                                                    <div class="fw-semibold">No cancelled orders yet</div>
                                                    <div class="small">Your cancelled orders will appear here.</div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <app-pagination *ngIf="cancelledOrdersMeta && cancelledOrdersMeta.totalRows > 0"
                                    [url]='url' [counts]='cancelledOrdersMeta'
                                    (refresh)="getOrder('Cancelled', $event)"></app-pagination>
                            </div>

                            <!-- FAILED -->
                            <div class="tab-pane fade" id="tabFailed" role="tabpanel">
                                <!-- LOADING SKELETON -->
                                <div *ngIf="loadingFailedOrders" class="card shadow-sm border-0">
                                    <div class="card-body p-4">
                                        <div class="placeholder-glow">
                                            <div class="placeholder col-4 mb-2"></div>
                                            <div class="placeholder col-7 mb-4"></div>
                                            <div class="placeholder col-12 mb-2"></div>
                                            <div class="placeholder col-10 mb-2"></div>
                                            <div class="placeholder col-8"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive" *ngIf="!loadingFailedOrders">
                                    <table class="table table-hover align-middle mb-0">
                                        <thead class="table-light">
                                            <tr class="small text-muted">
                                                <th style="min-width:160px;">Order</th>
                                                <th style="min-width:140px;">Pair</th>
                                                <th class="text-end" style="min-width:140px;">Amount</th>
                                                <th class="text-end" style="min-width:140px;">Remaining</th>
                                                <th class="text-end" style="min-width:120px;">Rate</th>
                                                <th style="min-width:120px;">Status</th>
                                                <th style="min-width:160px;">Created</th>
                                                <th class="text-end" style="min-width:160px;">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let order of failedOrders">
                                                <td>
                                                    <div class="d-flex align-items-center gap-2">
                                                        <span class="fw-semibold">
                                                            <a href="Javascript:void(0)" class="text-decoration-none"
                                                                (click)="viewOrder(order.id)">{{ shortId(order.id)
                                                                }}</a>
                                                        </span>

                                                        <button type="button" class="btn btn-link p-0 text-muted small"
                                                            (click)="copyToClipboard(order.id)"
                                                            title="Copy full Order ID" style="line-height:1;">
                                                            <i class="bi bi-clipboard"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td class="fw-semibold">{{order.fromCurrency.code}} →
                                                    {{order.toCurrency.code}}</td>
                                                <td class="text-end">{{ order.originalAmount |
                                                    smartAmount:order.fromCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.remainingAmount |
                                                    smartAmount:order.toCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.rate | smartAmount }}
                                                    {{order.toCurrency.code +
                                                    "/"+order.fromCurrency.code}}</td>
                                                <td><span
                                                        [class]="getOrderStatusClass(order.status)">{{order.status}}</span>
                                                </td>
                                                <td class="text-muted small">{{order.createdAt | date:'medium'}}</td>
                                                <td class="text-end">
                                                    <button class="btn btn-outline-secondary btn-sm"
                                                        (click)="viewOrder(order.id)">View</button>
                                                    <button class="btn btn-outline-danger btn-sm"
                                                        *ngIf="order.status == 'Open' || order.status == 'Partial'"
                                                        (click)="cancelOrder(order.id)">Cancel</button>
                                                </td>
                                            </tr>
                                            <tr *ngIf="failedOrders.length === 0">
                                                <td colspan="8" class="text-center py-5 text-muted">
                                                    <div class="fw-semibold">No failed orders yet</div>
                                                    <div class="small">Your failed orders will appear here.</div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <app-pagination *ngIf="failedOrdersMeta && failedOrdersMeta.totalRows > 0" [url]='url'
                                    [counts]='failedOrdersMeta' (refresh)="getOrder('Failed', $event)"></app-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <app-footer></app-footer>
    </main>
</div>
<!-- ORDER REVIEW MODAL -->
<div class="modal fade" id="orderReviewModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title fw-bold">
                    {{ isInstantMode ? 'Review Instant Trade' : 'Review Flexible Order' }}
                </h5>
                <button type="button" class="btn-close" (click)="closeReviewModal()"></button>
            </div>

            <div class="modal-body">
                <div class="small text-muted mb-3" *ngIf="isInstantMode">
                    Confirm the locked rate before it expires. SwipFx will use better market liquidity first and the
                    house will provide any required remainder.
                </div>
                <div class="small text-muted mb-3" *ngIf="!isInstantMode">
                    Confirm your preferred rate. This order may remain open until a compatible counter-order is found.
                </div>

                <div class="border rounded-3 p-3 bg-light-subtle">
                    <div class="d-flex justify-content-between mb-2">
                        <span class="text-muted">Pair</span>
                        <span class="fw-semibold">{{ haveCurrency?.value }} → {{ needCurrency?.value }}</span>
                    </div>

                    <div class="d-flex justify-content-between mb-2">
                        <span class="text-muted">Execution</span>
                        <span class="fw-semibold">{{ isInstantMode ? 'Instant' : 'Flexible' }}</span>
                    </div>

                    <div class="d-flex justify-content-between mb-2">
                        <span class="text-muted">You spend</span>
                        <span class="fw-semibold">
                            {{ (+haveAmount!.value) | smartAmount:haveCurrency?.value }}
                        </span>
                    </div>

                    <div class="d-flex justify-content-between mb-2">
                        <span class="text-muted">Fee ({{ fee }}%)</span>
                        <span class="fw-semibold">
                            {{ (+haveAmount!.value * fee / 100) | smartAmount:haveCurrency?.value }}
                        </span>
                    </div>

                    <div class="d-flex justify-content-between mb-2">
                        <span class="text-muted">Total spend</span>
                        <span class="fw-semibold">
                            {{ (+haveAmount!.value + (+haveAmount!.value * fee / 100)) | smartAmount:haveCurrency?.value
                            }}
                        </span>
                    </div>

                    <hr class="my-2">

                    <div class="d-flex justify-content-between mb-2">
                        <span class="text-muted">You receive</span>
                        <span class="fw-semibold">
                            {{ (+needAmount!.value) | smartAmount:needCurrency?.value }}
                        </span>
                    </div>

                    <div class="d-flex justify-content-between">
                        <span class="text-muted">Rate</span>
                        <span class="fw-semibold">
                            {{ (+price!.value) | number:'1.0-12' }} {{ needCurrency?.value }}/{{ haveCurrency?.value }}
                        </span>
                    </div>

                    <div class="d-flex justify-content-between mt-2" *ngIf="isInstantMode">
                        <span class="text-muted">Rate protection</span>
                        <span class="fw-semibold">Reconfirmed automatically at execution</span>
                    </div>

                    <hr class="my-2">

                    <div class="fw-semibold mb-2">Funding</div>

                    <div class="d-flex justify-content-between mb-2">
                        <span class="text-muted">Wallet currency</span>
                        <span class="fw-semibold">{{ haveCurrency?.value }}</span>
                    </div>

                    <div class="d-flex justify-content-between">
                        <span class="text-muted">Available</span>
                        <span class="fw-semibold">
                            {{ available | smartAmount:haveCurrency?.value }}
                        </span>
                    </div>
                </div>

                <div class="alert alert-warning mt-3 mb-0" *ngIf="errorObject?.error">
                    {{ errorObject?.message }}
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" (click)="closeReviewModal()"
                    [disabled]="loading">
                    Back
                </button>

                <button type="button" class="btn btn-primary" (click)="confirmPlaceOrder()"
                    [disabled]="!canPlaceOrder">
                    <span *ngIf="!loading && isInstantMode">Execute Instant Trade</span>
                    <span *ngIf="!loading && !isInstantMode">Place Flexible Order</span>
                    <span *ngIf="loading" class="spinner-border spinner-border-sm"></span>
                </button>
            </div>

        </div>
    </div>
</div>